import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=581689e8&"
import script from "./TagSelector.vue?vue&type=script&lang=ts&"
export * from "./TagSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports